import "./InterestsStatistics.scss";

import { Typography } from "../../ui";
import { DOMAIN_API_HOST } from "../../configs/main";
//import {Audience} from "../../modules/Audience";
import { CardWhite, Accordion, AccordionChildren } from "../../widgets";
import { useEffect, useState } from "react";

function InterestsStatistics({ counter_id, date_from, date_to, isMobile }) {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${DOMAIN_API_HOST}/api/v1/ya-metrika/detailed-segments?counter_id=${counter_id}&date_from=${new Date(date_from).toISOString().slice(0, 10)}&date_to=${new Date(date_to).toISOString().slice(0, 10)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error, status: ${response.status}`);
        }

        const data = await response.json();
        setData(data);

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (counter_id && date_from && date_to) {
      fetchData();
    }
  }, [counter_id, date_from, date_to]);
  
  if (!counter_id) {
    return (
      <div className="InterestsStatistics">
        <Typography variant="h2" color="dark-gray">
          Детальные интересы
        </Typography>
        <center style={{ marginTop: "40%", fontSize: "16px", color: "#666666" }}>Выберите счётчик</center>
      </div>
    );
  }
  return (
    <div className="InterestsStatistics" style={{ padding: "10px", width: isMobile ? "100%" : "auto", overflowX: isMobile ? "scroll" : "hidden" }}>
      <Typography variant="h2" color="dark-gray">
        Детальные интересы
      </Typography>

      {data.length > 0 && (
        <div style={isMobile ? { overflowX: 'auto', minWidth: 500 } : {}}>
          <div className="title-groups">
            <Typography
              className="name"
              variant="body1"
              color="dark-gray"
            ></Typography>
            <div className="items">
              <div className="item"></div>
              <div className="item">
                <Typography variant="span" color="dark-gray">
                  Размер сегмента
                </Typography>
              </div>
              <div className="item">
                <Typography variant="span" color="blue">
                  Affinity Index
                </Typography>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="statistics-content">
        {isLoading ? (
          <center style={{ marginTop: "46%", marginLeft: "8%" }}>Загрузка данных</center>
        ) : data.length ? (
          data?.map((interest, i) => (
            <Accordion
              key={i}
              title={interest?.label}
              shown={interest?.value}
              index={interest?.ai + "%"}
              items
            >
              {interest.categories?.map((subIt, j) => (
                <AccordionChildren
                  key={j}
                  titleChildren={subIt?.label}
                  shownChildren={subIt?.value}
                  indexChildren={subIt?.ai + "%"}
                  subItems={!!subIt?.categories?.length}
                  categories={subIt?.categories || []}
                />
              ))}
            </Accordion>
          ))
        ) : (
          <center style={{ marginTop: "46%", marginLeft: "8%" }}>Данные не найдены</center>
        )}
      </div>
    </div>
  );
}

export default InterestsStatistics;
